var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.54 27.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#07586b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graphics"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.67,0H3.87A3.92,3.92,0,0,0,0,4V23.39a3.93,3.93,0,0,0,3.87,4h31.8a3.94,3.94,0,0,0,3.87-4V4A3.93,3.93,0,0,0,35.67,0Zm1.75,4v19.4a2,2,0,0,1-.14.72L26.76,13.85Zm-23,11.3L17.24,18a3.78,3.78,0,0,0,5.1,0l2.88-2.67,10.2,10H4.13Zm4.3,1.1L3.34,2.21a1.64,1.64,0,0,1,.53-.09h31.8a1.65,1.65,0,0,1,.54.09L20.9,16.39A1.56,1.56,0,0,1,18.68,16.39Zm-5.86-2.52L2.27,24.13a1.92,1.92,0,0,1-.15-.74V4Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailButton);
export default __webpack_public_path__ + "static/media/EmailButton.cd4c58e5.svg";
export { ForwardRef as ReactComponent };